import { ReactNode } from 'react'
import Task from '../../../types/api/task'
import { DesignerTasksTableRow } from '../types/table-row'
import { isGroupHeader } from './row-helpers'

export const renderTaskOnly = (
    render: (record: Task, value: unknown) => ReactNode
) => {
    return (value: unknown, record: DesignerTasksTableRow) => {
        if (isGroupHeader(record)) return null
        return render(record, value)
    }
}

export const onHeaderHiddenCell = (record: DesignerTasksTableRow) =>
    isGroupHeader(record) ? { colSpan: 0 } : {}

export const HEADER_CONTENT_COL_SPAN = 5
